import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { AdminProvider } from './contexts/AdminContext';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import CompanyInfo from './pages/admin/CompanyInfo';
import VisionMission from './pages/admin/VisionMission';
import Products from './pages/admin/Products';
import Innovations from './pages/admin/Innovations';
import USPs from './pages/admin/USPs';
import Stats from './pages/admin/Stats';
import Inquiries from './pages/admin/Inquiries';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="company" element={<CompanyInfo />} />
              <Route path="vision-mission" element={<VisionMission />} />
              <Route path="products" element={<Products />} />
              <Route path="innovations" element={<Innovations />} />
              <Route path="usps" element={<USPs />} />
              <Route path="stats" element={<Stats />} />
              <Route path="inquiries" element={<Inquiries />} />
            </Route>
          </Routes>
          <Toaster />
        </AdminProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
